export default __webpack_public_path__ + "static/bench-beca853284504963f0fbb42578ff3c21.webp";